var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message-container message-container--info",class:{hide: !_vm.infoMessage},on:{"click":_vm.clearInfoMessage}},[(_vm.infoMessage)?_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.infoMessage))]):_vm._e(),_vm._v(" "),_c('i',{staticClass:"fa fa-times message-close"})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c085640","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/InfoMessage.vue
// module id = EFbU
// module chunks = 0